module.exports = __webpack_public_path__ + "img/delivery-reviews.3fd59fbf.svg";